import { render, staticRenderFns } from "./ContentEditableComponent.vue?vue&type=template&id=6d3b8b40&scoped=true"
import script from "./ContentEditableComponent.vue?vue&type=script&lang=ts"
export * from "./ContentEditableComponent.vue?vue&type=script&lang=ts"
import style0 from "./ContentEditableComponent.vue?vue&type=style&index=0&id=6d3b8b40&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3b8b40",
  null
  
)

export default component.exports